import React, { useState } from 'react'
import { FormQuickConnectOuterDiv, FieldGroup, Label, Select, Input, TextArea, SubTitle, StartupSection, ConnectionSection } from './style'

export interface QuickConnectModalProps {
  startupId: string
}

export const QuickConnectModal = ({ startupId }: QuickConnectModalProps): JSX.Element => {
  const [startupName, setStartupName] = useState<string>('')
  const [startupEmail, setstartupEmail] = useState<string>('')
  const [representant, setRepresentant] = useState<string>('')
  const [contactPhone, setContactPhone] = useState<string>('')
  const [source, setSource] = useState<string>('')
  const [responsible, setResponsible] = useState<string>('')
  const [areaInterest, setAreaInterest] = useState<string>('')
  const [description, setDescription] = useState<string>('')

  return (
    <FormQuickConnectOuterDiv>
      <SubTitle>Sobre a startup</SubTitle>
      <StartupSection>
        <FieldGroup>
          <Label className='required'>Nome da Startup</Label>
          <Input
            type='text'
            value={startupName}
            onChange={(e) => setStartupName(e.target.value)}
            placeholder='Digite o nome da startup'
          />
          <small className='field-error-text' data-error-for='startupName' style={{ color: '#dc3545', textAlign: 'left' }}></small>
        </FieldGroup>
        <FieldGroup>
          <Label className='required'>E-mail da startup/projeto</Label>
          <Input
            type='text'
            value={startupEmail}
            onChange={(e) => setstartupEmail(e.target.value)}
            placeholder='Digite o e-mail da startup'
          />
          <small className='field-error-text' data-error-for='startupEmail' style={{ color: '#dc3545', textAlign: 'left' }}></small>
        </FieldGroup>
        <FieldGroup>
          <Label className='required'>Nome do representante</Label>
          <Input
            type='text'
            value={representant}
            onChange={(e) => setRepresentant(e.target.value)}
            placeholder='Digite o nome do representante'
          />
          <small className='field-error-text' data-error-for='representant' style={{ color: '#dc3545', textAlign: 'left' }}></small>
        </FieldGroup>
        <FieldGroup>
          <Label className='required'>Telefone de contato</Label>
          <Input
            type='number'
            value={contactPhone}
            onChange={(e) => setContactPhone(e.target.value)}
            placeholder='Digite o telefone de contato'
          />
          <small className='field-error-text' data-error-for='contactPhone' style={{ color: '#dc3545', textAlign: 'left' }}></small>
        </FieldGroup>
      </StartupSection>
      <SubTitle>Sobre a conexão</SubTitle>
      <ConnectionSection>
        <FieldGroup>
          <Label className='required'>Fonte de conexão</Label>
          <Select
            value={source}
            onChange={(e) => setSource(e.target.value)}
          >
            <option value='' disabled>Selecione</option>
            <option value='Evento'>Evento</option>
            <option value='Indicação'>Indicação</option>
            <option value='Pesquisa Online'>Pesquisa Online</option>
            <option value='Redes sociais'>Redes sociais</option>
          </Select>
          <small className='field-error-text' data-error-for='source' style={{ color: '#dc3545', textAlign: 'left' }}></small>
        </FieldGroup>
        <FieldGroup>
          <Label className='required'>Responsável pela conexão</Label>
          <Input
            type='text'
            value={responsible}
            onChange={(e) => setResponsible(e.target.value)}
            placeholder='Digite o nome do responsável pela conexão'
          />
          <small className='field-error-text' data-error-for='responsible' style={{ color: '#dc3545', textAlign: 'left' }}></small>
        </FieldGroup>
        <FieldGroup>
          <Label className='required'>Área/instituição de interesse</Label>
          <Input
            type='text'
            value={areaInterest}
            onChange={(e) => setAreaInterest(e.target.value)}
            placeholder='Prefeitura ou outras instituições públicas, empresas privadas, áreas internas da caixa'
          />
          <small className='field-error-text' data-error-for='areaInterest' style={{ color: '#dc3545', textAlign: 'left' }}></small>
        </FieldGroup>
        <FieldGroup>
          <Label>Descrição</Label>
          <TextArea
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            placeholder='Digite uma descrição sobre a conexão'
            rows={4}
          />
        </FieldGroup>
      </ConnectionSection>
    </FormQuickConnectOuterDiv>
  )
}